// Wishlist ------------------------------------------------------------------------

function toggleWishlist(event) {
  let pdpData = {};
  const productElement = event.currentTarget.closest('[data-product]');
  if (productElement) {
    pdpData = {
      productTitle: productElement.dataset.title,
      productImg: productElement.dataset.image,
      productPrice: productElement.dataset.price,
      productUrl: productElement.dataset.url,
      productLabel: productElement.dataset.label || '',
    };
  } else {
    console.log('Product element not found.');
    return;
  }

  let wishlistData = JSON.parse(localStorage.getItem('wishlist')) || [];
  const isAlreadyInWishlist = wishlistData.some((item) => item.productTitle === pdpData.productTitle);

  if (!isAlreadyInWishlist) {
    wishlistData.push(pdpData);
    localStorage.setItem('wishlist', JSON.stringify(wishlistData));

    // Redirect to wishlist page
    window.location.href = '/pages/wishlist';
  } else {
    // Already in wishlist, optionally still redirect
    window.location.href = '/pages/wishlist';
  }

  displayWishlist();
}

function removeFromWishlist(productTitle) {
  let wishlistData = JSON.parse(localStorage.getItem('wishlist')) || [];
  wishlistData = wishlistData.filter((item) => item.productTitle !== productTitle);
  localStorage.setItem('wishlist', JSON.stringify(wishlistData));
  displayWishlist();
}

function displayWishlist() {
  const wishlistData = JSON.parse(localStorage.getItem('wishlist')) || [];
  const wishlistBlock = document.querySelector('.js-wishlistBlock');

  if (!wishlistBlock) {
    console.log('Element with class "js-wishlistBlock" not found');
    return;
  }

  if (wishlistData.length === 0) {
    wishlistBlock.innerHTML = '<p>Your wishlist is empty.</p>';
    return;
  }

  const wishlistHtml = wishlistData
    .map(
      (item) => `
      <div class="wishlist-product__list c-product">
        <div class="wishlist-product">
          <a href="${item.productUrl}">
            <img src="${item.productImg}" alt="${item.productTitle}">
          </a>
          <h3 class="c-product__title card__heading h5">
            <a class="full-unstyled-link" href="${item.productUrl}">${item.productTitle}</a>
          </h3>
          <p class="product-price price-item" data-base-price="${item.productPrice.replace(/[^0-9.]/g, '')}">${
        item.productPrice
      }</p>
          ${item.productLabel ? `<span class="product-label badge">${item.productLabel}</span>` : ''}
          <button class="wishlist-page-button" onclick="removeFromWishlist('${item.productTitle}')">Remove</button>
        </div>
      </div>
    `
    )
    .join('');

  wishlistBlock.innerHTML = wishlistHtml;

  const savedCurrency = localStorage.getItem('selectedCurrency');
  if (savedCurrency) {
    updatePrices(savedCurrency);
  }
}

document.addEventListener('DOMContentLoaded', function () {
  displayWishlist();
});

document.addEventListener('click', function () {
  setTimeout(() => {
    const savedCurrency = localStorage.getItem('selectedCurrency');
    if (savedCurrency) {
      updatePrices(savedCurrency);
    }
  }, 2000);
});

// Currency ----------------------------------------------------------

const BASE_CURRENCY = 'usd';
const CURRENCIES = ['usd', 'gbp', 'eur', 'cad', 'nzd', 'sar', 'qar', 'jpy', 'zar', 'aud'];

let selectedCurrencyText = document.querySelector(".selected-currency");
let currencyOptions = document.querySelector("#drawerSelectedCurrency");
let currencyOptions2 = document.querySelector("#drawerSelectedCurrency2");

let currencyFooterOptions = document.querySelector("#drawerFooterSelectedCurrency");

// Load saved currency on page load
const savedCurrency = localStorage.getItem("selectedCurrency");
if (savedCurrency) {
  let matchedOption = document.querySelector(`#currency-buttons li[data-currency="${savedCurrency}"]`);
  console.log(savedCurrency);
  if (matchedOption) {
    let currencyFlag = matchedOption.querySelector("span").innerHTML;
    selectedCurrencyText.innerHTML = currencyFlag; // insert SVG directly
  }
}

// Handle clicks

async function fetchExchangeRates() {
  const url = `https://cdn.jsdelivr.net/npm/@fawazahmed0/currency-api@latest/v1/currencies/${BASE_CURRENCY}.json`;

  try {
    const res = await fetch(url);
    const data = await res.json();

    if (data[BASE_CURRENCY]) {
      document.getElementById('exchange-rates').dataset.rates = JSON.stringify(data[BASE_CURRENCY]);
      applySavedCurrency();
    }
  } catch (error) {
    console.log('Error fetching exchange rates:', error);
  }
}

function convertPrice(originalPrice, targetCurrency) {
  const rates = JSON.parse(document.getElementById('exchange-rates').dataset.rates || '{}');
  const rate = rates[targetCurrency];
  if (!rate) return originalPrice;
 return Math.round(originalPrice * rate).toLocaleString();
}


function updatePrices(currency) {
  document.querySelectorAll('.price-item').forEach((el) => {
    const basePrice = parseFloat(el.dataset.basePrice);
    let currencySymbol;
    if (currency.toUpperCase() == 'USD') {
      currencySymbol = '$';
    } else if (currency.toUpperCase() == 'GBP') {
      currencySymbol = '£';
    } else if (currency.toUpperCase() == 'EUR') {
      currencySymbol = '€';
    } else if (currency.toUpperCase() == 'JPY') {
      currencySymbol = '¥';
    } else {
      currencySymbol = currency.toUpperCase();
    }
    el.textContent = `${currencySymbol} ${convertPrice(basePrice, currency)}`;
    // show after update
    el.style.visibility = 'visible';
    document.querySelectorAll('.selected-currency').forEach(selectedCurrency => {
      selectedCurrency.textContent = currency.toUpperCase();
    });
  });
  const path = window.location.pathname;

  if (path.includes("/products")) {
    if(currency.toUpperCase() == "AED" || currency.toUpperCase() == "SAR" || currency.toUpperCase() == "QAR" || currency.toUpperCase() == "KWD" || currency.toUpperCase() == "BHD"){
      document.getElementById("tabby-monthly-amount").style.display = "flex";
    }else{
      document.getElementById("tabby-monthly-amount").style.display = "none";
    }
  }

  document.querySelectorAll(".checkout-massage-for-difcuruser").forEach(el => {
    if (el){
      if(currency.toUpperCase() != "USD"){
        el.style.display = "block";
      }else{
        el.style.display = "none";
      }
    }
  });
  
}

function applySavedCurrency() {
  // Map some country codes to currencies if needed
  const countryCurrencyMap = {
    'AF': 'afn',
    'AX': 'eur',
    'AL': 'all',
    'DZ': 'dzd',
    'AS': 'usd',
    'AD': 'eur',
    'AO': 'aoa',
    'AI': 'xcd',
    'AG': 'xcd',
    'AR': 'ars',
    'AM': 'amd',
    'AW': 'awg',
    'AU': 'aud',
    'AT': 'eur',
    'AZ': 'azn',
    'BS': 'bsd',
    'BH': 'bhd',
    'BD': 'bdt',
    'BB': 'bbd',
    'BY': 'byn',
    'BE': 'eur',
    'BZ': 'bzd',
    'BJ': 'xof',
    'BM': 'bmd',
    'BT': 'btn',
    'BO': 'bob',
    'BQ': 'usd',
    'BA': 'bam',
    'BW': 'bwp',
    'BR': 'brl',
    'IO': 'usd',
    'VG': 'usd',
    'BN': 'bnd',
    'BG': 'bgn',
    'BF': 'xof',
    'BI': 'bif',
    'KH': 'khr',
    'CM': 'xaf',
    'CA': 'cad',
    'CV': 'cve',
    'KY': 'kyd',
    'CF': 'xaf',
    'TD': 'xaf',
    'CL': 'clp',
    'CN': 'cny',
    'CX': 'aud',
    'CC': 'aud',
    'CO': 'cop',
    'KM': 'kmf',
    'CG': 'xaf',
    'CD': 'cdf',
    'CK': 'nzd',
    'CR': 'crc',
    'CI': 'xof',
    'HR': 'hrk',
    'CU': 'cup',
    'CW': 'ang',
    'CY': 'eur',
    'CZ': 'czk',
    'DK': 'dkk',
    'DJ': 'djf',
    'DM': 'xcd',
    'DO': 'dop',
    'EC': 'usd',
    'EG': 'egp',
    'SV': 'usd',
    'GQ': 'xaf',
    'ER': 'ern',
    'EE': 'eur',
    'ET': 'etb',
    'FK': 'fkp',
    'FO': 'dkk',
    'FJ': 'fjd',
    'FI': 'eur',
    'FR': 'eur',
    'PF': 'xpf',
    'GA': 'xaf',
    'GM': 'gmd',
    'GE': 'gel',
    'DE': 'eur',
    'GH': 'ghs',
    'GI': 'gip',
    'GR': 'eur',
    'GL': 'dkk',
    'GD': 'xcd',
    'GP': 'eur',
    'GU': 'usd',
    'GT': 'gtq',
    'GN': 'gnf',
    'GW': 'xof',
    'GY': 'gyd',
    'HT': 'htg',
    'HN': 'hnl',
    'HK': 'hkd',
    'HU': 'huf',
    'IS': 'isk',
    'IN': 'inr',
    'ID': 'idr',
    'IR': 'irr',
    'IQ': 'iqd',
    'IE': 'eur',
    'IL': 'ils',
    'IT': 'eur',
    'JM': 'jmd',
    'JP': 'jpy',
    'JO': 'jod',
    'KZ': 'kzt',
    'KE': 'kes',
    'KI': 'aud',
    'KP': 'kpw',
    'KR': 'krw',
    'KW': 'kwd',
    'KG': 'kgs',
    'LA': 'lak',
    'LV': 'eur',
    'LB': 'usd', // lbp org but change in usd by client requirment
    'LS': 'lsl',
    'LR': 'lrd',
    'LY': 'lyd',
    'LI': 'chf',
    'LT': 'eur',
    'LU': 'eur',
    'MO': 'mop',
    'MK': 'mkd',
    'MG': 'mga',
    'MW': 'mwk',
    'MY': 'myr',
    'MV': 'mvr',
    'ML': 'xof',
    'MT': 'eur',
    'MH': 'usd',
    'MQ': 'eur',
    'MR': 'mru',
    'MU': 'mur',
    'YT': 'eur',
    'MX': 'mxn',
    'FM': 'usd',
    'MD': 'mdl',
    'MC': 'eur',
    'MN': 'mnt',
    'ME': 'eur',
    'MS': 'xcd',
    'MA': 'mad',
    'MZ': 'mzn',
    'MM': 'mmk',
    'NA': 'nad',
    'NR': 'aud',
    'NP': 'npr',
    'NL': 'eur',
    'NC': 'xpf',
    'NZ': 'nzd',
    'NI': 'nio',
    'NE': 'xof',
    'NG': 'ngn',
    'NU': 'nzd',
    'NF': 'aud',
    'MP': 'usd',
    'NO': 'nok',
    'OM': 'omr',
    'PK': 'pkr',
    'PW': 'usd',
    'PA': 'pab',
    'PG': 'pgk',
    'PY': 'pyg',
    'PE': 'pen',
    'PH': 'php',
    'PN': 'nzd',
    'PL': 'pln',
    'PT': 'eur',
    'PR': 'usd',
    'QA': 'qar',
    'RE': 'eur',
    'RO': 'ron',
    'RU': 'rub',
    'RW': 'rwf',
    'BL': 'eur',
    'SH': 'shp',
    'KN': 'xcd',
    'LC': 'xcd',
    'MF': 'eur',
    'PM': 'eur',
    'VC': 'xcd',
    'WS': 'wst',
    'SM': 'eur',
    'ST': 'stn',
    'SA': 'sar',
    'SN': 'xof',
    'RS': 'rsd',
    'SC': 'scr',
    'SL': 'sll',
    'SG': 'sgd',
    'SX': 'ang',
    'SK': 'eur',
    'SI': 'eur',
    'SB': 'sbd',
    'SO': 'sos',
    'ZA': 'zar',
    'SS': 'ssp',
    'ES': 'eur',
    'LK': 'lkr',
    'SD': 'sdg',
    'SR': 'srd',
    'SJ': 'nok',
    'SE': 'sek',
    'CH': 'chf',
    'SY': 'syp',
    'TW': 'twd',
    'TJ': 'tjs',
    'TZ': 'tzs',
    'TH': 'thb',
    'TL': 'usd',
    'TG': 'xof',
    'TO': 'top',
    'TT': 'ttd',
    'TN': 'tnd',
    'TR': 'try',
    'TM': 'tmt',
    'TC': 'usd',
    'TV': 'aud',
    'UG': 'ugx',
    'UA': 'uah',
    'AE': 'aed',
    'GB': 'gbp',
    'US': 'usd',
    'UY': 'uyu',
    'UZ': 'uzs',
    'VU': 'vuv',
    'VE': 'ves',
    'VN': 'vnd',
    'VG': 'usd',
    'VI': 'usd',
    'EH': 'mad',
    'YE': 'yer',
    'ZM': 'zmw',
    'ZW': 'zwl'
  };
  navigator.geolocation.getCurrentPosition(
    // SUCCESS CALLBACK
    async (position) => {

      let usercountrycode = localStorage.getItem("user_country_code");
      if(usercountrycode){
        localStorage.removeItem("user_country_code");
      }

      // 1. check saved FIRST
      let savedCountry = localStorage.getItem("local_country_code");

      let countryCode = "";

      if (savedCountry) {
        countryCode = savedCountry;
      } else {

        const lat = position.coords.latitude;
        const lng = position.coords.longitude;

        const res = await fetch(
          `https://nominatim.openstreetmap.org/reverse?lat=${lat}&lon=${lng}&format=json`
        );

        const data = await res.json();

        countryCode = data.address.country_code.toUpperCase();

        // save ONLY country code
        localStorage.setItem("local_country_code", countryCode);
      }

      // 2. currency mapping
      const currency = countryCurrencyMap[countryCode] || "usd";


      // 3. set global currency
      window.GEO_CURRENCY = currency;

      // 4. save currency
      let savedCurrency = localStorage.getItem("selectedCurrency");

      if (!savedCurrency) {
        localStorage.setItem('selectedCurrency', currency);
      }

      console.log(currency, savedCountry);

      // 5. update prices
      updatePrices(savedCurrency || currency);
    },

    // ERROR CALLBACK
    (error) => {

      console.log("Location denied or unavailable");

      const defaultCurrency = "usd";

      window.GEO_CURRENCY = defaultCurrency;

      let savedCurrency = localStorage.getItem("selectedCurrency");

      if (!savedCurrency) {
        localStorage.setItem("selectedCurrency", defaultCurrency);
      }

      // DEFAULT USD
      updatePrices(savedCurrency || defaultCurrency);
    }

  );

}
// function applySavedCurrency() {
//   const savedCurrency = localStorage.getItem('selectedCurrency');
//   if (savedCurrency && CURRENCIES.includes(savedCurrency)) {
//     updatePrices(savedCurrency);
//   }
// }

// function applySavedCurrency() {
//   const savedCurrency = localStorage.getItem('selectedCurrency');

//   if (savedCurrency && CURRENCIES.includes(savedCurrency)) {
//     updatePrices(savedCurrency);
//   } else {
//     localStorage.setItem('selectedCurrency', BASE_CURRENCY);
//     updatePrices(BASE_CURRENCY);
//   }
// }

// On currency button click
document.querySelectorAll('#currency-buttons li').forEach((btn) => {
  btn.addEventListener('click', () => {
    const selectedCurrency = btn.dataset.currency;
    const savedCurrency = localStorage.getItem('selectedCurrency');
    const closeCurReminderModal = localStorage.getItem('closeCurReminderModal');

    if(closeCurReminderModal != "true" && selectedCurrency != savedCurrency){
      document.getElementById("currencyModal").style.display = "flex";

      localStorage.setItem('selectedCurrency', selectedCurrency);
      // let matchedOption = document.querySelector(`#currency-buttons li[data-currency="${selectedCurrency}"] span svg`);
      // localStorage.setItem('selectedCurrencyFlag' ,  matchedOption.outerHTML);
    }else{
      proceedCurrency(selectedCurrency)
    }
  });
});
document.getElementById("closeCurrencyModal").onclick = function(){
  // localStorage.setItem('closeCurReminderModal' ,  'true');
  localStorage.removeItem("selectedCurrency");
  // localStorage.removeItem("selectedCurrencyFlag");
  
  document.getElementById("currencyModal").style.display = "none";
  window.location.reload();
}

document.getElementById("proceedCurrency").onclick = function(){
  document.getElementById("currencyModal").style.display = "none";
  localStorage.setItem('closeCurReminderModal' ,  'true');
  const savedCurrency = localStorage.getItem('selectedCurrency');
  proceedCurrency(savedCurrency)
}
function proceedCurrency(currency){
  localStorage.setItem('selectedCurrency', currency);
  // let matchedOption = document.querySelector(`#currency-buttons li[data-currency="${currency}"] span svg`);
  // localStorage.setItem('selectedCurrencyFlag' ,  matchedOption.outerHTML);

  updatePrices(currency);
  const mainBody = document.querySelector('body');
  const closeCurDrawer = document.getElementById('drawer');
  const closeMenuDrawer = document.getElementById('Details-menu-drawer-container-custom');
  const menuDrawerSum = closeMenuDrawer.querySelector("summary[aria-label='Menu']");
  // currencyOptions.innerHTML = matchedOption.outerHTML;
  // currencyOptions2.innerHTML = matchedOption.outerHTML; 
  // currencyFooterOptions.innerHTML = matchedOption.outerHTML;

  closeCurDrawer.classList.remove('open');
  mainBody.classList.remove('overflow-hidden-desktop');
  closeMenuDrawer.removeAttribute('open');
  menuDrawerSum.setAttribute('aria-expanded', 'false');
}

// Init
fetchExchangeRates();

// ==========================
// COLOR FILTER + CUSTOM INFINITE
// ==========================

// GLOBAL STATES
let currentColorFilter = [];

let isInfiniteLoading = false;
let hasMorePages = true;

function setInfiniteState(loading, more) {
  isInfiniteLoading = loading;
  hasMorePages = more;
}


// LOAD SAVED COLORS
function loadSavedColors() {
  const saved = JSON.parse(localStorage.getItem("selectedColors") || "[]");
  if (saved.length === 0) return;

  currentColorFilter = saved;

  saved.forEach(color => {
    const btn = document.querySelector(`[data-color="${color}"]`);
    if (btn) btn.classList.add("active");
  });

  filterProductsByColor(saved);
}


// FILTER PRODUCTS
function filterProductsByColor(selectedColors) {
  hideNoProductsMessage();

  selectedColors.forEach(selectedColor => {
    const selectedColorFilter = document.querySelector(".active-facets.active-facets-mobile");

    if (selectedColorFilter) {

      const capitalName =
        selectedColor.charAt(0).toUpperCase() +
        selectedColor.slice(1).toLowerCase();

      const exists = [
        ...selectedColorFilter.querySelectorAll(".active-facets__button-inner")
      ].some(el =>
        el.textContent
          .trim()
          .toLowerCase()
          .includes(`color: ${selectedColor.toLowerCase()}`)
      );

      if (exists) return;

      const currentUrl = window.location.href;

      const wrapper = document.createElement("facet-remove");
      wrapper.innerHTML = `
        <a href="${currentUrl}" class="active-facets__button active-facets__button--light" role="button">
          <span class="active-facets__button-inner button button--tertiary">
            Color: ${capitalName}
            <span class="svg-wrapper">
              <svg xmlns="http://www.w3.org/2000/svg" fill="none" class="icon icon-close-small" viewBox="0 0 12 13">
                <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" d="M8.486 9.33 2.828 3.67M2.885 9.385l5.544-5.77"></path>
              </svg>
            </span>
            <span class="visually-hidden">Remove filter</span>
          </span>
        </a>
      `;
      wrapper.classList.add("custom-active-color");

      selectedColorFilter.prepend(wrapper);
    }
  });

  if(selectedColors != null){

    const productBanners = document.querySelectorAll(".product-grid .grid-banner");

    if(productBanners){
      productBanners.forEach(banner => {
        banner.style.display = "none";
      });
    }

  }

  const productCards = document.querySelectorAll(".product-grid .grid__item");

  productCards.forEach(card => {
    setTimeout(() => {
      const swatches = card.querySelectorAll("[data-value]");

      let hasColor = false;
      swatches.forEach(swatch => {
        const swatchColor = swatch
          .getAttribute("data-value")
          ?.toLowerCase();

        if (
          selectedColors.includes(swatchColor) &&
          swatch.getAttribute("current-product") === "true"
        ) {
          hasColor = true;
        }
      });

      card.style.display = hasColor ? "block" : "none";
    }, 500);
  });

  applySavedCurrencyAfterFilter();

  setTimeout(() => {
    evaluateNoProducts();
  }, 1200);
}


// EVALUATE NO PRODUCTS
function evaluateNoProducts() {
  if (isInfiniteLoading || hasMorePages) return;

  const visibleProducts = document.querySelectorAll(
    ".product-grid .grid__item:not([style*='display: none'])"
  ).length;

  showNoProductsMessage(
    visibleProducts === 0,
    currentColorFilter.join(", ")
  );
}


// NO PRODUCTS MESSAGE
function showNoProductsMessage(show, color) {
  let messageEl = document.getElementById("no-products-message");

  if (show && !messageEl) {
    messageEl = document.createElement("div");
    messageEl.id = "no-products-message";
    messageEl.style.textAlign = "center";
    messageEl.style.padding = "2rem";
    messageEl.style.color = "#666";
    messageEl.innerHTML = `No products found for color: <strong>${color}</strong>`;

    const grid = document.querySelector(".product-grid");
    if (grid) grid.appendChild(messageEl);

  } else if (!show && messageEl) {
    messageEl.remove();
  }
}

function hideNoProductsMessage() {
  const messageEl = document.getElementById("no-products-message");
  if (messageEl) messageEl.remove();
}


// SHOW ALL PRODUCTS
function showAllProducts() {
  document.querySelectorAll(".product-grid .grid__item").forEach(card => {
    card.style.display = "";
  });
  hideNoProductsMessage();
}


// COLOR BUTTON HANDLERS
function initializeColorFilters() {
  const colorButtons = document.querySelectorAll(".color-filter-option");

  colorButtons.forEach(btn => {
    btn.addEventListener("click", function (e) {
      e.preventDefault();

      const selectedColor = this.dataset.color;

      if (currentColorFilter.includes(selectedColor)) {
        currentColorFilter = currentColorFilter.filter(
          c => c !== selectedColor
        );
        this.classList.remove("active");
      } else {
        currentColorFilter.push(selectedColor);
        this.classList.add("active");
      }

      localStorage.setItem(
        "selectedColors",
        JSON.stringify(currentColorFilter)
      );
    });
  });

  const applyBtn = document.querySelector(".apply-filters-btn");
  if (applyBtn) {
    applyBtn.addEventListener("click", e => {
      e.preventDefault();
      if (currentColorFilter.length === 0) {
        showAllProducts();
      } else {
        window.location.reload();
      }
    });
  }
}


// FILTER OBSERVER
function setupFilterObserver() {
  const filterContainer = document.querySelector(".filter-container");
  if (!filterContainer) return;

  const observer = new MutationObserver(() => {
    initializeColorFilters();
  });

  observer.observe(filterContainer, {
    childList: true,
    subtree: true
  });
}


// CURRENCY
function applySavedCurrencyAfterFilter() {
  const savedCurrency = localStorage.getItem("selectedCurrency");
  if (savedCurrency) {
    updatePrices(savedCurrency);
  }
}

// custom filter button & filter selected tabs handling

const mobileMenuClose = document.querySelector(".menu-drawer__navigationMobile .header__icon");
mobileMenuClose.addEventListener('click', () => {
  document.querySelector('body').classList.remove('overflow-hidden-desktop');
});

let selectedHref = null;

document.querySelectorAll(".mobile-facets__list-custom .mobile-facets__label")
  .forEach(filterBtn => {
    filterBtn.addEventListener("click", function (e) {
      e.preventDefault();

      // const label = this.querySelector('.mobile-facets__label');
      const isActive = this.classList.contains("active");

      // If already active → remove
      if (isActive) {
        this.classList.remove("active");
        selectedHref = null;
        return;
      }

      // Remove all active labels
      document.querySelectorAll(".mobile-facets__list-custom .mobile-facets__label.active")
        .forEach(activeBtn => activeBtn.classList.remove("active"));

      // Add active to clicked one
      this.classList.add("active");

      // Save selected collection href
      selectedHref = this.getAttribute("href");
    });
  });

document.querySelectorAll(".facets-layout-list .mobile-facets__label")
  .forEach(facetBtn => {
    facetBtn.addEventListener("click", function (e) {
      const isActive = this.classList.contains("active");

      // If already active → remove
      if (isActive) {
        this.classList.remove("active");
      }

    });
  })

document.addEventListener("click", (e) => {
  if (e.target.classList.contains("apply-filters-btn")) {
    e.preventDefault();

    const form = document.querySelector("facet-filters-form form");
    const facetClass = document.querySelector("facet-filters-form");

    let finalURL = null;

    if (form && facetClass) {
      // Shopify filter params
      const searchParams = facetClass.createSearchParams(form);
      const facetQuery = searchParams.toString(); // removes the "?"

      // If collection selected
      if (selectedHref) {
        if (facetQuery) {
          finalURL = `${selectedHref}?${facetQuery}&filter.v.availability=1`;
        } else {
          finalURL = `${selectedHref}`;
        }
      } 
      else {
        // No collection, only facet filters
        if (facetQuery) {
          finalURL = `?${facetQuery}&filter.v.availability=1`;
        }
      }

      // If we built a final URL → go to it
      if (finalURL) {
        window.location.href = finalURL;
        return;
      }

      // Else → fallback Shopify submit (no collection + empty filters)
      facetClass.onSubmitForm(searchParams, e);
    }
  }
});


function activateCollectionTabOnLoad() {
  const currentURL = window.location.pathname.toLowerCase();

  const tabs = document.querySelectorAll(".mobile-facets__list-custom .mobile-facets__label"); // <-- apne tab ka class yahan likho

  tabs.forEach(tab => {
    const tabURL = tab.getAttribute("href")?.toLowerCase();

    if (tabURL && currentURL.includes(tabURL)) {
      tab.classList.add("active");
    } else {
      tab.classList.remove("active");
    }
  });
}

document.addEventListener("DOMContentLoaded", function () {
  activateCollectionTabOnLoad();
  // localStorage.removeItem("local_country_code");
});


document.addEventListener("DOMContentLoaded", function () {
  const sortTabs = document.querySelectorAll(".sort-tab");

  sortTabs.forEach(tab => {
    tab.addEventListener("click", function (e) {
      e.preventDefault();

      const selectedSort = this.value;

      // Get current real URL (with all filters)
      const url = new URL(window.location.href);

      // Add OR update sort_by param
      url.searchParams.set("sort_by", selectedSort);

      // Redirect to updated URL (filters remain safe)
      window.location.href = url.toString();
    });
  });
});

document.addEventListener("click", function (e) {
  const btn = e.target.closest("facet-remove.custom-active-color");

  if (btn) {
    e.preventDefault();

    const innerSpan = btn.querySelector(".active-facets__button-inner");
    if (!innerSpan) return;

    // Option: Split by line break
    const fullText = innerSpan.innerText.trim();
    const colorToRemove = fullText
      .replace("Color:", "")
      .split("\n")[0] 
      .trim()
      .toLowerCase();

    // remove color from localStorage array
    let storedColors = JSON.parse(localStorage.getItem("selectedColors")) || [];
    const updatedArray = storedColors.filter(color => color.toLowerCase() !== colorToRemove);

    localStorage.setItem("selectedColors", JSON.stringify(updatedArray));

    console.log("Updated Colors:", updatedArray);

    // REMOVE the UI button itself
    btn.remove();

    // Reload the page
    window.location.reload();
  }
  const removeBtn = e.target.closest(".active-facets__button-remove");
  if(removeBtn){
    localStorage.removeItem("selectedColors");
    setTimeout(() => {
      // Reload the page
      window.location.reload();
    }, 1000);
  }
  const drawerRemoveBtn = e.target.closest("facet-remove .mobile-facets__clear");
  if(drawerRemoveBtn){
    localStorage.removeItem("selectedColors");
    setTimeout(() => {
      // Reload the page
      window.location.reload();
    }, 1000);
  }
  const normalFacetBtn = e.target.closest("facet-remove:not(.custom-active-color)");
  if(normalFacetBtn){
    setTimeout(() => {
      // Reload the page
      window.location.reload();
    }, 1000);
  }
  const productSizeBtn = e.target.closest(".product-variant-size input[data-product-url]");
  if(productSizeBtn){
    const elSep = document.querySelector(".timesact-button-bis");
    elSep.classList.remove("soldOut");
    setTimeout(() => {
      const el = document.querySelector(".timesact-button-bis");
  
      if (el && el.style.display != "none") {
        el.removeAttribute("style");
        el.classList.add("soldOut");
      }else{
        el.classList.remove("soldOut");
      }
    }, 1500);
  }
});

// custom infinite scroll

// document.addEventListener("DOMContentLoaded", () => {
//   let page = 1;
//   let isLoading = false;
//   let hasMore = true;

//   const grid = document.querySelector(".product-grid");

//   const loader = document.getElementById("infinite-loader");

//   if (!grid) return;

//   async function loadMoreProducts() {
//     if (isLoading || !hasMore) return;

//     isLoading = true;
//     loader.style.display = "block";
//     page++;

//     // Preserve ALL existing filters
//     const urlObj = new URL(window.location.href);
//     urlObj.searchParams.set("page", page);

//     try {
//       const res = await fetch(urlObj.toString());
//       if (!res.ok) throw new Error("No more pages");

//       const html = await res.text();
//       const doc = new DOMParser().parseFromString(html, "text/html");

//       const newProducts = doc.querySelectorAll(
//         ".product-grid .grid__item"
//       );

//       if (!newProducts.length) {
//         hasMore = false;
//         return;
//       }

//       // newProducts.forEach(item => grid.appendChild(item));

//       // Re-apply ONLY custom JS logic
//       if (currentColorFilter.length > 0) {
//         newProducts.forEach(item => {
//           item.style.display = "none";
//           grid.appendChild(item);
//         });
//         filterProductsByColor(currentColorFilter);
//       }else{
//         newProducts.forEach(item => grid.appendChild(item));
//       }

//       // Re-run currency conversion after DOM update
//       setTimeout(() => {
//         if (typeof applySavedCurrencyAfterFilter === "function") {
//           applySavedCurrencyAfterFilter();
//         }
//       }, 500);

//     } catch (e) {
//       hasMore = false;

//     } finally {
//       isLoading = false;
//       loader.style.display = "none";
//     }
//   }

//   window.addEventListener("scroll", () => {
//     if (
//       window.innerHeight + window.scrollY >=
//       document.body.offsetHeight - 400
//     ) {
//       loadMoreProducts();
//     }
//   });
// });


// ==========================
// CUSTOM INFINITE SCROLL
// ==========================

document.addEventListener("DOMContentLoaded", () => {
  const path = window.location.pathname;

  if (!path.includes("/search") && !path.includes("/collections")) return;

  loadSavedColors();
  initializeColorFilters();
  setupFilterObserver();

  let page = 1;
  let isLoading = false;
  let hasMore = true;
  let isAutoLoadingAll = false;

  const grid = document.querySelector(".product-grid");
  const loader = document.getElementById("infinite-loader");

  if (!grid) return;

  async function loadMoreProducts() {
    if (isLoading || !hasMore) return;

    isLoading = true;
    setInfiniteState(true, hasMore);

    if(loader) loader.style.display = "block";
    page++;

    const urlObj = new URL(window.location.href);
    urlObj.searchParams.set("page", page);

    try {
      const res = await fetch(urlObj.toString());
      if (!res.ok) throw new Error("No more pages");

      const html = await res.text();
      const doc = new DOMParser().parseFromString(html, "text/html");

      const newProducts =
        doc.querySelectorAll(".product-grid .grid__item");

      if (!newProducts.length) {
        hasMore = false;
        setInfiniteState(false, false);
        evaluateNoProducts();
        return;
      }

      if (currentColorFilter.length > 0) {
        newProducts.forEach(item => {
          item.style.display = "none";
          grid.appendChild(item);
        });

        filterProductsByColor(currentColorFilter);
      } else {
        newProducts.forEach(item => grid.appendChild(item));
      }

      setTimeout(() => {
        applySavedCurrencyAfterFilter();
      }, 400);

    } catch (e) {
      hasMore = false;

    } finally {
      isLoading = false;
      if(loader) loader.style.display = "none";

      setInfiniteState(false, hasMore);
      evaluateNoProducts();
    }
  }

  async function loadAllFilteredProducts() {
    if (isAutoLoadingAll) return;
    isAutoLoadingAll = true;

    while (hasMore) {
      await loadMoreProducts();
    }

    isAutoLoadingAll = false;
  }

  // FILTER ACTIVE
  if (currentColorFilter.length > 0) {
    loadAllFilteredProducts();
    return;
  }

  // NORMAL SCROLL
  window.addEventListener("scroll", () => {
    if (
      window.innerHeight + window.scrollY >=
      document.body.offsetHeight - 300
    ) {
      loadMoreProducts();
    }
  });
});


// scroll on color filter applied

scrollDownIfColorFilterApplied = () => {
  setTimeout(() => {
    window.scrollTo({ top: 200, behavior: "smooth" });
  }, 2000);
};

document.addEventListener("DOMContentLoaded", () => {
  let customActiveColors = document.querySelectorAll(".custom-active-color");
  if (customActiveColors.length > 0) {
    scrollDownIfColorFilterApplied();
  }
  const path = window.location.pathname;

  if (path.includes("/products")) {
    document.querySelector(".header-wrapper").classList.add("product-page-header")
    document.querySelector("footer.footer ").classList.add("product-page-footer")
  }
  setTimeout(() => {
    const el = document.querySelector(".timesact-button-bis");

    if (el && el.style.display != "none") {
      el.removeAttribute("style");
      el.classList.add("soldOut");
    }else{
      el.classList.remove("soldOut");
    }
  }, 6000);
});

// ==========================
// UAE GEOLOCATION + TABBY
// ==========================

// document.addEventListener("DOMContentLoaded", () => {

//   const tabbyElement = document.getElementById("tabby-monthly-amount");

//   // Tabby ko initially hide rakho
//   if (tabbyElement) {
//     tabbyElement.style.display = "none";
//   }

//   // Saved country check
//   const savedCountry = localStorage.getItem("local_country_code");

//   if (savedCountry) {
//     handleTabbyByCountry(savedCountry);
//     return;
//   }

//   // Get user's location
//   if (!navigator.geolocation) {
//     console.log("Geolocation is not supported.");
//     handleTabbyByCountry(null);
//     return;
//   }

//   navigator.geolocation.getCurrentPosition(
//     async (position) => {

//       try {

//         const lat = position.coords.latitude;
//         const lng = position.coords.longitude;

//         const res = await fetch(
//           `https://nominatim.openstreetmap.org/reverse?lat=${lat}&lon=${lng}&format=json`
//         );

//         if (!res.ok) {
//           throw new Error("Reverse geolocation failed");
//         }

//         const data = await res.json();

//         const countryCode =
//           data.address?.country_code?.toUpperCase() || null;

//         console.log("Detected Country:", countryCode);

//         // Save country
//         if (countryCode) {
//           localStorage.setItem("local_country_code", countryCode);
//         }

//         handleTabbyByCountry(countryCode);

//       } catch (error) {

//         console.log("Country detection error:", error);

//         // Error -> Hide Tabby
//         handleTabbyByCountry(null);
//       }
//     },

//     (error) => {

//       console.log("Location denied/unavailable:", error);

//       // Permission denied -> Hide Tabby
//       handleTabbyByCountry(null);
//     },

//     {
//       enableHighAccuracy: false,
//       timeout: 10000,
//       maximumAge: 3600000
//     }
//   );
// });


// ==========================
// TABBY COUNTRY CHECK
// ==========================

// function handleTabbyByCountry(countryCode) {

//   const tabbyElement = document.getElementById("tabby-monthly-amount");

//   if (!tabbyElement) return;

//   if (countryCode === "AE") {

//     // UAE -> SHOW TABBY
//     tabbyElement.style.display = "flex";

//     console.log("UAE detected → Tabby shown");

//   } else {

//     // Non-UAE -> HIDE TABBY
//     tabbyElement.style.display = "none";

//     console.log("Non-UAE detected → Tabby hidden");
//   }
// }